import { FEATURED_PRODUCTS } from '@/data/products';
import { Product } from '@/types/product';

export type SortOption = 'name-asc' | 'name-desc' | 'price-asc' | 'price-desc';

const RECENT_SEARCHES_KEY = 'dispensary_recent_searches';
const MAX_RECENT_SEARCHES = 5;

export function getRecentSearches(): string[] {
  try {
    const stored = localStorage.getItem(RECENT_SEARCHES_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

export function addRecentSearch(query: string): void {
  if (!query.trim()) return;

  try {
    const recent = getRecentSearches();
    const filtered = recent.filter(
      s => s.toLowerCase() !== query.toLowerCase()
    );
    const updated = [query, ...filtered].slice(0, MAX_RECENT_SEARCHES);
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(updated));
  } catch {
    return;
  }
}

export function clearRecentSearches(): void {
  try {
    localStorage.removeItem(RECENT_SEARCHES_KEY);
  } catch {
    return;
  }
}

export const recentSearches = [
  'Paracetamol',
  'Vitamin C',
  'Antibiotics',
  'Blood pressure',
  'Diabetes medication',
];

export function getFilteredProducts(
  searchQuery: string,
  category: string | null,
  prescription: boolean | null,
  sortBy: SortOption
): Product[] {
  let filtered = [...FEATURED_PRODUCTS];

  // Apply search filter
  if (searchQuery) {
    const query = searchQuery.toLowerCase();
    filtered = filtered.filter(
      product =>
        product.title.toLowerCase().includes(query) ||
        product.category.toLowerCase().includes(query)
    );
  }

  // Apply category filter
  if (category) {
    filtered = filtered.filter(product => product.category === category);
  }

  // Apply prescription filter
  if (prescription !== null) {
    filtered = filtered.filter(
      product => product.prescription === prescription
    );
  }

  // Apply sorting
  switch (sortBy) {
    case 'name-asc':
      filtered.sort((a, b) => a.title.localeCompare(b.title));
      break;
    case 'name-desc':
      filtered.sort((a, b) => b.title.localeCompare(a.title));
      break;
    case 'price-asc':
      filtered.sort((a, b) => a.price - b.price);
      break;
    case 'price-desc':
      filtered.sort((a, b) => b.price - a.price);
      break;
  }

  return filtered;
}

export function getPrescriptionCount(): number {
  return FEATURED_PRODUCTS.filter(product => product.prescription).length;
}

export function getOtcCount(): number {
  return FEATURED_PRODUCTS.filter(product => !product.prescription).length;
}

export function sortProducts(
  products: import('@/types/product').Product[],
  sortBy: SortOption
): import('@/types/product').Product[] {
  const sorted = [...products];

  switch (sortBy) {
    case 'name-asc':
      sorted.sort((a, b) => a.title.localeCompare(b.title));
      break;
    case 'name-desc':
      sorted.sort((a, b) => b.title.localeCompare(a.title));
      break;
    case 'price-asc':
      sorted.sort((a, b) => a.price - b.price);
      break;
    case 'price-desc':
      sorted.sort((a, b) => b.price - a.price);
      break;
  }

  return sorted;
}
